export default class CompaniesService {
  static async getAllCompanies(token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/companies`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch companies');
    return response.json();
  }

  static async getCompanyById(companyId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/companies/${companyId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch company');
    return response.json();
  }

  static async createCompany(companyData, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/companies`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(companyData),
    });
    if (!response.ok) throw new Error('Failed to create company');
    
    // Handle 204 No Content response
    if (response.status === 204) {
      return null; // No response body
    }
    
    // Check if response has content before parsing JSON
    const contentLength = response.headers.get('content-length');
    if (contentLength === '0') {
      return null; // Empty response body
    }
    
    const text = await response.text();
    if (!text.trim()) {
      return null; // Empty or whitespace-only response
    }
    
    return JSON.parse(text);
  }

  static async updateCompany(companyData, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/companies`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(companyData),
    });
    if (!response.ok) throw new Error('Failed to update company');
    
    // Handle 204 No Content response
    if (response.status === 204) {
      return null; // No response body
    }
    
    // Check if response has content before parsing JSON
    const contentLength = response.headers.get('content-length');
    if (contentLength === '0') {
      return null; // Empty response body
    }
    
    const text = await response.text();
    if (!text.trim()) {
      return null; // Empty or whitespace-only response
    }
    
    return JSON.parse(text);
  }

  static async deleteCompany(companyId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/companies/${companyId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to delete company');
    
    // Handle 204 No Content response
    if (response.status === 204) {
      return null; // No response body
    }
    
    // Check if response has content before parsing JSON
    const contentLength = response.headers.get('content-length');
    if (contentLength === '0') {
      return null; // Empty response body
    }
    
    const text = await response.text();
    if (!text.trim()) {
      return null; // Empty or whitespace-only response
    }
    
    return JSON.parse(text);
  }
}
